import React, { useState, useEffect } from "react";
import {
  Button,
  FormControl,
  FormLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  IconButton,
  InputAdornment,
} from "@material-ui/core";
import useStyles from "../../../../styles";
import axios from "axios";
import { decryptData } from "../../../../crypto";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";

function AddAddScoreSchemeForm() {
  const classes = useStyles();

  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const navigate = useNavigate();

  const [formdata, setFormData] = useState({
    scheme_name:"",
    mark:"",
    negative_marking:"",
    negative_marking_score:"",
    partial_mark:"",
    bonus:""
  })

  const handleClose = () => {
    navigate("/admin/scorescheme");
  };

  const menuProps = {
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left",
    },
    disablePortal: true,
  };

  // const handleChange = (e) =>{
  //    const { name, value } = e.target;
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     [name]: value
  //   }));
  // }

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   if (name === "negative_marking_score") {
  //     // Convert input to negative value
  //     const numericValue = parseFloat(value);
  //     const negativeValue = isNaN(numericValue) ? "" : -Math.abs(numericValue);
  //     setFormData((prevData) => ({
  //       ...prevData,
  //       [name]: negativeValue,
  //     }));
  //   } else {
  //     setFormData((prevData) => ({
  //       ...prevData,
  //       [name]: value,
  //     }));
  //   }
  // };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "negative_marking_score") {
      // Convert input to negative value, reject 0
      const numericValue = parseFloat(value);
      const negativeValue =
        isNaN(numericValue) || numericValue === 0 ? "" : -Math.abs(numericValue);
      setFormData((prevData) => ({
        ...prevData,
        [name]: negativeValue,
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  // const handleFormSubmit = () => {
   
  //   // Validation
  //   if (!formdata.scheme_name.trim()) {
  //     toast.warn("Please enter a scheme name.");
  //     return;
  //   }
  //   if (!formdata.mark || isNaN(formdata.mark) || Number(formdata.mark) <= 0) {
  //     toast.warn("Please enter a valid positive mark.");
  //     return;
  //   }
  //   if (!formdata.negative_marking) {
  //     toast.warn("Please select negative marking option.");
  //     return;
  //   }
  //   if (formdata.negative_marking === "yes" && (!formdata.negative_marking_score || isNaN(formdata.negative_marking_score) || Number(formdata.negative_marking_score) <= 0)) {
  //     toast.warn("Please enter a valid positive negative mark.");
  //     return;
  //   }
  //   if (!formdata.partial_mark) {
  //     toast.warn("Please select partial marking option.");
  //     return;
  //   }
  //   if (!formdata.bonus || isNaN(formdata.bonus) || Number(formdata.bonus) < 0) {
  //     toast.warn("Please enter a valid bonus (0 or positive).");
  //     return;
  //   }

  //   const data = {
  //       scheme_name: formdata.scheme_name,
  //       mark: Number(formdata.mark),
  //       negative_marking: formdata.negative_marking,
  //       negative_marking_score: formdata.negative_marking === "yes" ? Number(formdata.negative_marking_score) : 0,
  //       partial_mark: formdata.partial_mark,
  //       bonus: Number(formdata.bonus)
  //     };


  //   axios
  //     .post(
  //       `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/subject_section/add`,
  //       data,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${decryptedToken}`,
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     )
  //     .then((response) => {
  //       setTimeout(() => {
  //         navigate("/admin/scorescheme");
  //       }, 2000);
  //       toast.success("Scheme created successfully");
  //     })
  //     .catch((error) => {
  //       toast.error("Scheme is not created");
  //     });
  // };

  const handleFormSubmit = async () => {
    // Validation
    if (!formdata.scheme_name.trim()) {
      toast.warn("Please enter a scheme name.");
      return;
    }
    if (!formdata.mark || isNaN(formdata.mark) || Number(formdata.mark) <= 0) {
      toast.warn("Please enter a valid positive mark.");
      return;
    }
    if (!formdata.negative_marking) {
      toast.warn("Please select negative marking option.");
      return;
    }
    // if (formdata.negative_marking === "yes" &&
    //  (!formdata.negative_marking_score || 
    // isNaN(formdata.negative_marking_score) || Number(formdata.negative_marking_score) <= 0)) {
    //   toast.warn("Please enter a negative mark.");
    //   return;
    // }
    if (
      formdata.negative_marking === "yes" &&
      (!formdata.negative_marking_score ||
        isNaN(formdata.negative_marking_score) ||
        Number(formdata.negative_marking_score) >= 0)
    ) {
      toast.warn("Please enter a valid negative mark (must be negative).");
      return;
    }
    if (!formdata.partial_mark) {
      toast.warn("Please select partial marking option.");
      return;
    }
    // if (!formdata.bonus || isNaN(formdata.bonus || Number(formdata.bonus) <= 0)) {
    if (formdata.bonus === "" || isNaN(formdata.bonus) || Number(formdata.bonus) < 0) {
      toast.warn("Please enter a valid bonus.");
      return;
    }

    try {
      const data = {
        scoring_scheme :{
        scheme_name: formdata.scheme_name,
        mark: Number(formdata.mark),
        negative_marking: formdata.negative_marking,
        negative_marking_score: formdata.negative_marking === "yes" ? Number(formdata.negative_marking_score) : 0,
        partial_mark: formdata.partial_mark,
        bonus: Number(formdata.bonus)
        }
      };

      // console.log("Payload:", JSON.stringify(data, null, 2)); // Debug: Log payload

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/scoring/schemes/add`,
        data,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        toast.success("Scheme created successfully");
        setTimeout(() => {
          navigate("/admin/scorescheme");
        }, 2000);
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
        toast.error(`${error.response.data.message}`);
      } else {
        toast.error("An unexpected error occurred while creating the scheme.");
      }
      console.error("An error occurred:", error);
    }
  };

  return (
    <>
      <ToastContainer />

      <div
        className={`${classes.mt1} ${classes.mt1} ${classes.inputpadding} ${classes.inputborder} ${classes.pagescroll}`}
      >
        <FormControl className={`${classes.w100}`}>
          <div
            className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py2} ${classes.px1_5} ${classes.mt1}`}
          >
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              >
                Scheme Details
              </Typography>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w36}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Scheme Name <span className={classes.textcolorred}>*</span>
                </FormLabel>

                <TextField
                  type="text"
                  variant="outlined"
                  required
                   name="scheme_name"
                   onChange={handleChange}
                   value={formdata.scheme_name}
                  placeholder="Enter scheme name"
                />
              </div>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w37}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Mark <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  type="number"
                  variant="outlined"
                  required
                  name="mark"
                  onChange={handleChange}
                  value={formdata.mark}
                  placeholder="Enter mark"
                />
              </div>


            </div>
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              >

              </Typography>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Negative Marking <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Select
                  labelId="category-label"
                  id="negMarking"
                   value={formdata.negative_marking}
                   onChange={handleChange}
                   name="negative_marking"
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem disabled value="">
                    <em className={classes.defaultselect}>Select marking</em>
                  </MenuItem>

                  <MenuItem value="yes">
                    Yes
                  </MenuItem>
                  <MenuItem value="no">
                    No
                  </MenuItem>
                </Select>
              </div>
              {formdata.negative_marking === "yes" &&
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Negative Mark <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  type="number"
                  variant="outlined"
                  required
                  name="negative_marking_score"
                  onChange={handleChange}
                  value={formdata.negative_marking_score}
                  placeholder="Enter negative mark"
                />
              </div>
}
                <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Partial Marking <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <Select
                  labelId="category-label"
                  id="negMarking"
                  name="partial_mark"
                   value={formdata.partial_mark}
                   onChange={handleChange}
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem disabled value="">
                    <em className={classes.defaultselect}>Select marking</em>
                  </MenuItem>

                  <MenuItem value="yes">
                    Yes
                  </MenuItem>
                  <MenuItem value="no">
                    No
                  </MenuItem>
                </Select>
              </div>
{formdata.negative_marking !== "yes" &&
<div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Bonus <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  type="number"
                  variant="outlined"
                  required
                  name="bonus"
                  onChange={handleChange}
                  value={formdata.bonus}
                  placeholder="Enter bonus"
                />
              </div>
}

            </div>
{formdata.negative_marking === "yes" &&
            <div
              className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.mt1}`}
            >
              <Typography
                className={`${classes.w24} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
                variant="h6"
                display="inline"
              >

              </Typography>

              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Bonus <span className={classes.textcolorred}>*</span>
                </FormLabel>
                <TextField
                  type="number"
                  variant="outlined"
                  required
                  name="bonus"
                  onChange={handleChange}
                  value={formdata.bonus}
                  placeholder="Enter bonus"
                />
              </div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              ></div>
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24}`}
              ></div>

            </div>
}
          </div>
          <div
            className={`${classes.dflex} ${classes.justifyflexend} ${classes.mt1}`}
          >
            <Button
              className={`${classes.custombtnoutline}`}
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              onClick={handleFormSubmit}
              className={`${classes.custombtnblue}`}
            >
              Submit
            </Button>
          </div>
        </FormControl>
      </div>
    </>
  );
}
export default AddAddScoreSchemeForm;
